<template>
    <div class='title-container' :class="[computedClass, 'mobile-content-head']">
        <h2 
            :class="{ 'clickable': isBackButton }" 
            @click="handleClick"
        >
            <span v-if="isBackButton" class="arrow-polygon">
                 <img src="@/assets/images/polygon1.png" alt="Back Arrow" class="back-arrow-icon" />
             </span>

            {{ isBackButton ? '一覧に戻る' : title }}
        </h2>
        <slot name="button"></slot>
    </div>
</template>

<script>
export default {
  name: 'TitleContainer',
  props: {
    title: {
        type: String,
        required: true
    },
    isExtraWidth: {
        type: Boolean,
        default: false
    }
  },
  computed: {
    computedClass() {
        return this.isExtraWidth ? 'mx-5' : 'container content-head';
    },
    isBackButton() {
        return this.title === '一覧に戻る' || this.title === '< 一覧に戻る';
    }
  },
  methods: {
    handleClick() {
        if (this.isBackButton) {
            this.$router.go(-1);
        }
    }
  }
};
</script>

<style scoped>
.clickable {
    cursor: pointer;
}

.clickable:hover {
    opacity: 0.7;
}

.bg-gray {
    background: #EDEDED; 
}
.content-head {
    height: 75px;
    /* border-bottom: 1px solid #B3B3B3; */
}

.title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #E7F6F6 !important;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

h2 {
   padding: 15px 0px 0px 0px;
   font-size: 20px;
   font-weight: bold;
   display: flex;
   align-items: center;
   color: #016d6b;
}

.arrow-polygon {
   margin-right: 8px;
   display: inline-flex;
   align-items: center;
}

.back-arrow-icon {
   width: 14px;
   height: 14px;
   object-fit: contain;
}

/* Mobile styles */
@media (max-width: 1024px) {
    .container {
        max-width: 960px !important;
        margin-left: auto;
        margin-right: auto;
    } 
    h2 {
       font-size: 20px;
    }
    .mobile-content-head {
        height: 55px !important;
        /* border-bottom: 1px solid #B3B3B3 !important; */
        padding: 0px 5px;
    }
    .mx-5 {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
}

@media (min-width: 1200px) {
    .title-container.container {
        /* max-width: 1140px; */
        margin-left: auto;
        margin-right: auto;
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .title-container.container {
        max-width: 960px;
        margin-left: auto;
        margin-right: auto;
    }
}

@media (max-width: 768px) {
    h2 {
       font-size: 16px;  /* Mobile specific size */
    }
}

</style>
